if (process.env.NODE_ENV === "production") {
  console.log = () => { };
  console.debug = () => { };
  console.warn = () => { };
}

const isNationalAction = process.env.REACT_APP_IS_NATIONAL === "true";

import React, { createContext, useEffect, useState } from "react";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import { loadFromStorage, saveToStorage } from "./utils/cartStorage";

import axios from "axios";
import Home from "./Home";
import Activities from "./Activities";
import Content from "./Content";
import Admin from "./Admin";
import Login from "./Login";
import TopNav from "./TopNav";
import TopMenu from "./TopMenu";
import Onboarding from "./Onboarding";
import SignupOrLogin from "./SignupOrLogin";
import FilterMenu from "./FilterMenu";
import ProtectedRoute from "./ProtectedRoute";
import Athletes from "./Athletes";
import AthletePage from "./AthletePage";
import Organization from "./Organization";
import Kleurplaat from "./Kleurplaat";
import DonationComplete from "./DonationComplete";
import BottomBar from "./BottomBar";


axios.defaults.withCredentials = true;

export const PopupContext = createContext();
// Shared athlete session state — fetched once on app load, accessible in any component
export const AthleteContext = createContext(null);


function Layout({ children }) {
  return (
    <div>
      <TopMenu />
      <div className="content">
        {children}
      </div>
      <BottomBar />
    </div>
  );
}

export default function App() {

  const [showTraining, setShowTraining] = useState(loadFromStorage("showTraining", false));
  const [showEvent, setShowEvent] = useState(loadFromStorage("showEvent", false));
  const [selectedAthlete, setSelectedAthlete] = useState(loadFromStorage("selectedAthlete", "all"));
  const [currentAthlete, setCurrentAthlete] = useState(null);
  const [sessionChecked, setSessionChecked] = useState(false);

  useEffect(() => {
    saveToStorage("showTraining", showTraining);
  }, [showTraining]);

  useEffect(() => {
    saveToStorage("showEvent", showEvent);
  }, [showEvent]);

  useEffect(() => {
    saveToStorage("selectedAthlete", selectedAthlete);
  }, [selectedAthlete]);

  // Check whether there is an active athlete session on app load.
  // Uses /athlete/session (always 200) so the browser does not log a
  // 401 in the devtools console for logged-out visitors.
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/athlete/session`, { credentials: "include" })
      .then(r => r.json())
      .then(data => setCurrentAthlete(data.authenticated ? data.athlete : null))
      .catch(() => { })
      .finally(() => setSessionChecked(true));
  }, []);

  return (
    <AthleteContext.Provider value={{ currentAthlete, setCurrentAthlete, sessionChecked }}>
      <Router>
        <Layout>
          <TopNav />
          <FilterMenu
            showTraining={showTraining}
            setShowTraining={setShowTraining}
            showEvent={showEvent}
            setShowEvent={setShowEvent}
            selectedAthlete={selectedAthlete}
            setSelectedAthlete={setSelectedAthlete}
          />
          <Routes>
            <Route path="/" element={<Home selectedAthlete={selectedAthlete} showEvent={showEvent} showTraining={showTraining} />} />
            <Route path="/kaart" element={<Activities selectedAthlete={selectedAthlete} showEvent={showEvent} showTraining={showTraining} />} />
            <Route path="/aanmelden" element={<SignupOrLogin />} />
            <Route path="/deelnemers" element={<Athletes />} />
            <Route path="/deelnemers/:athleteId" element={<AthletePage />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/onboarding/:id" element={<Navigate to="/onboarding" replace />} />
            {isNationalAction && (
              <>
                <Route path="/organisatie" element={<Organization />} />
                <Route path="/kleurplaat" element={<Kleurplaat />} />
              </>
            )}
            <Route path="/donatie-bevestiging" element={<DonationComplete />} />
            <Route path="/content/:pageKey" element={<Content />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              } />
            <Route path="/login" element={<Login />} />
          </Routes>
        </Layout>
      </Router>
    </AthleteContext.Provider>
  );
}